/**
 * What the console says before a run that will not use the planner — spec 013 §7.
 *
 * Its own function because there is more than one way to end up on `outline` and the
 * console used to name only one of them. It said "No subscription token is configured"
 * on a deployment holding a valid 108-character token, because the API had declined the
 * planner for memory and reported the answer without the reason. A message that is confidently wrong
 * about the cause sends whoever reads it to check the wrong thing.
 */
export function plannerWarning(
  plannerNext: string,
  declined: string | undefined,
): string | undefined {
  if (plannerNext !== 'outline') return undefined;

  const cause = declined ?? 'No ANTHROPIC_API_KEY is configured';

  return `${cause}, so this run will write shaped placeholders rather than lessons. The job records \`outline\` as its planner.`;
}
